"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalAlignment = exports.HorizontalAlignmentContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const util_1 = require("../util");
exports.HorizontalAlignmentContainer = styled_components_1.default.div `
  text-align: ${(props) => (0, util_1.horizontalAlignmentToTextAlign)(props.alignment)};
`;
const HorizontalAlignment = ({ alignment, children, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.HorizontalAlignmentContainer, Object.assign({ alignment: alignment }, { children: children })));
};
exports.HorizontalAlignment = HorizontalAlignment;
